import classNames from 'classnames'
import React, { ReactNode, InputHTMLAttributes } from 'react'

import { preventEnter } from '../logic/keyboard'

import IconWarning from './icons/IconWarning'
import Label from './Label'

import './LabeledInput.scss'

export interface LabeledInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  fieldId?: string
  icon?: React.ReactNode
  isInvalid?: boolean
  label: ReactNode
  onChange: (newVal: string) => void
  placeholder?: string
  required?: boolean
  sublabel?: string
  type?: React.HTMLInputTypeAttribute
  value: string
  warn?: boolean
}

const LabeledInput = ({
  className,
  fieldId,
  icon,
  isInvalid,
  label,
  onChange,
  sublabel,
  type = 'text',
  warn,
  ...props
}: LabeledInputProps) => {
  return (
    <Label
      className={classNames('labeledInput', {
        'labeledInput--invalid': isInvalid,
      })}
      icon={icon}
      isRequired={props.required}
      text={label}
    >
      <input
        autoComplete="off"
        className={classNames(
          'labeledInput__input',
          'inputField',
          {
            'inputField--invalid': isInvalid,
          },
          className,
        )}
        name={fieldId}
        onChange={e => onChange(e.target.value)}
        onKeyPress={preventEnter}
        type={type}
        {...props}
      />
      {sublabel && (
        <div className={classNames('sublabel', { 'sublabel--warn': warn })}>
          {warn && <IconWarning width={20} height={20} />}
          {sublabel}
        </div>
      )}
    </Label>
  )
}

export default LabeledInput
